import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { gsap, ScrollTrigger} from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Disable / enable scroll
const stopScroll = () => {
  disableBodyScroll(document.body);
};

const startScroll = () => {
  enableBodyScroll(document.body);
};

const resizeObserver = new ResizeObserver(entries => {
  ScrollTrigger.refresh(true);
});

resizeObserver.observe(document.body);

export { stopScroll, startScroll };
